import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { CoreModule } from 'src/app/core/core.module';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { InputTextarea } from 'primeng/inputtextarea';
import { SurveysListComponent } from './surveys-list/surveys-list.component';
import { SurveysDetailComponent } from './surveys-detail/surveys-detail.component';
import { SurveysRoutingModule } from './surveys-routing.module';
import { SurveyDetailQuestionComponent } from './surveys-detail/question/question.component';
import { InputNumberModule } from 'primeng/inputnumber';
import { QuestionOptionComponent } from './surveys-detail/question/question-option/question-option.component';


@NgModule({ declarations: [
        SurveysListComponent,
        SurveysDetailComponent,
        SurveyDetailQuestionComponent,
        QuestionOptionComponent
    ], imports: [CoreModule,
        CommonModule,
        CardModule,
        ButtonModule,
        CheckboxModule,
        InputTextModule,
        PasswordModule,
        FormsModule,
        TableModule,
        CardModule,
        TabViewModule,
        CalendarModule,
        MessagesModule,
        SurveysRoutingModule,
        ReactiveFormsModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        ConfirmDialogModule,
        DropdownModule,
        DynamicDialogModule,
        InputTextarea], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SurveysModule { }
